import timesync from 'timesync';

import { DNode } from '@dojo/framework/core/interfaces';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import Button from '@dojo/widgets/button';

import { convertToBoolean } from '@holmescorp/common';

import { CountdownTimer } from '../widgets/countdown-timer';
import css from '../css/mcquestion.m.css';
import { IResult, QFResultData, QRLocator } from '../interfaces';
import { setQuestion } from '../support/state';
import MCQuestionBase from './mc-base';

@theme(css)
export class MCQuestionPretest extends MCQuestionBase {
	protected onChange(value: string): void {
		const { question, quizstore } = this.properties;
		question.distractororder.forEach((key) => {
			question.distractordata[key].chosen = false;
		});
		question.distractordata[+value].chosen = true;
		question.answer = value;
		setQuestion(quizstore)({ question });
		this.invalidate();
	}

	protected update_result(): Promise<any> {
		const { question, updater } = this.properties;
		const { icode = {}, status, cursor, answer } = question;
		const data: QFResultData = {
			answer,
			icode: { ...icode, _answer: answer as any },
			starttime: question.starttime!,
			stoptime: timesync.now().toJSON(),
			isseen: true,
			ismarked: false
		};
		const qrlocator: QRLocator = {
			status,
			cursor,
			qrid: '',
			quiz: ''
		};
		const result: IResult = { qrlocator, data };
		return updater([result]);
	}

	protected render_buttons(which: { islast?: boolean; isfeedback?: boolean }): DNode[] {
		const {
			messages: {
				finish: finishText = '',
				submit: submitText = '',
				show_pretest_timer = 'true',
				show_posttest_timer = 'true'
			}
		} = this.properties.localizedBundle;
		const { quizstore, quizkind, onNextQuestion, onFinish, theme } = this.properties;
		const { islast = false } = which;
		let showTimer = true;
		if (quizkind == 'pretest') {
			showTimer = convertToBoolean(show_pretest_timer);
		} else if (quizkind == 'posttest') {
			showTimer = convertToBoolean(show_posttest_timer);
		}

		const buttons = [
			islast
				? v('div', { classes: [this.theme(css.oneaction), this.theme(css.primaryButton)] }, [
						w(
							Button,
							{
								key: 'finish',
								onClick: async () => {
									if (!this._inFinish) {
										this._inFinish = true;
										await this.update_result();
										onFinish();
									}
								}
							},
							[finishText]
							// tslint:disable-next-line:indent
						)
				  ])
				: v('div', { classes: [this.theme(css.oneaction), this.theme(css.primaryButton)] }, [
						w(
							Button,
							{
								theme,
								key: 'submit',
								onClick: () => {
									if (!this._inSubmit) {
										this._inSubmit = true;
										this.update_result().then(() => {
											onNextQuestion();
										});
									}
								}
							},
							[submitText]
							// tslint:disable-next-line:indent
						)
				  ]),
			showTimer
				? v('div', { key: 'timer', classes: [this.theme(css.timerblock)] }, [
						v('div', { classes: [this.theme(css.timer)] }, [
							w(CountdownTimer, { quizstore, countdown: '' })
						])
				  ])
				: null
		];

		return buttons;
	}

	protected render(): DNode {
		return this.render_question();
	}
}

export default MCQuestionPretest;
